import DocumentReader from "../components/DocumentReader"
import { getLibraryContentUrl } from "../Helpers"


export default function JournalAccess({ data, watermark }) {
  return <DocumentReader
    data={{ ...data, contentUrl: getLibraryContentUrl(data.fileAccessToken) }}
    label="journal"
    watermark={watermark}
  />
}
